import React, { Component } from 'react';
import { withStyles, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';

// sample text halasz Terms of use
const TermsOfUseText = `<div>
<b>제1조(목적)</b>
<br />
<br />
이 약관은 (주)두원시스템 회사(이하 '회사')가 운영하는 스탬프투어 라 함은 회사가 제공하는 '스탬프투어' 브랜드를 사용하는
서비스와 관련하여 이용조건 및 사용자 권리 및 의무 사항을 규정함을 목적으로 합니다.
<br />
<br />
<br />
<b>제2조(약관의 명시, 효력 및 변경)</b>
<br />
<br />
1. 본 약관의 내용은 회사가 제공하는 개별 서비스 또는 서비스 초기 화면에 게시하거나 기타의 방법으로 공지하고, 본 약관에
동의한 모든 사용자에게 그 효력이 발생합니다.
<br />
<br />
2. 회사는 필요한 경우 관련 법령을 위배하지 않는 법위 내에서 본 약관을 변경할 수 있습니다. 본 약관이 변경되는 경우 회사는
변경 사항을 시행일자 15일 전부터 사용자에게 공지 또는 통지하는 것을 원칙으로 하며, 피치 못하게 사용자에게 불리한 내용으로
변경 할 경우에는 그 시행일자 30일 전부터 가입한 이메일 주소로 이메일을 발송하거나, 알림 메세지를 띄우는 등 합리적으로
가능한 방법으로 변경사항을 공지합니다.
<br />
<br />
3. 회사가 전 항에 따라 공지하면서 공지 또는 통지일로부터 개정약관 시행일 7일 후까지 거부의사를 표시하지 아니하면 승인한
것으로 본다는 뜻을 명확하게 고지하였음에도 사용자의 의사표시가 없는 경우에는 변경된 약관을 승인한 것으로 봅니다.
<br />
<br />
4. 본 약관에서 정하지 아니한 사항과 이 약관의 해석에 관하여는 전자상거래 등에서의 소비자보호에 관한 법률, 약관의 규제에 관한
법률, 공정거래위원회가 정하는 전자상거래 등에서의 소비자 보호지침 및 관련 법령 또는 일반 상관례에 따릅니다. <br />
<br />
<br />
<br />
<b>제3조 (계약의 성립)</b>
<br />
<br />
1. 이용 계약은 회사에서 제공하는 서비스를 이용하기 위해 회원이 되고자 하는자가 약관의 내용에 동의를 하고, 회사가 정한 양식에
따라 회원 정보(사용자명,이메일주소, 비밀번호, 전화번호 등등)를 기입하여 회원가입 신청을 하면, 이용신청에 대한 회사의 이용
승낙으로 성립합니다.
<br />
<br />
<br />
<b>제4조 (서비스 이용)</b>
<br />
<br />
1. 회사는 여행코스 정보 제공 서비스, QR코드 기반 서비스 등 사용자가 PC와 스마트폰으로 즐길 수 있는 다양한 서비스를
제공합니다. 사용자는 스마트폰이나 PC 환경에서 웹페이지에 접속하여 서비스를 이용할 수 있습니다.
<br />
<br />
2. 회사는 더 나은 서비스의 제공을 위하여 여러분에게 서비스의 이용과 관련된 각종 고지, 관리 메시지 및 기타 광고를 비롯한
다양한 정보를 서비스에 표시하거나 여러분의 메일 계정으로 직접 발송할 수 있습니다.
<br />
<br />
3. 서비스 이용 중 시스템 오류 등 문제점을 발견하신다면 언제든지 1:1 문의나 고객센터 메일로 알려 주시기 바랍니다.
</div>`;

const styles = (theme) => ({});

class TermsOfUse extends Component {
  constructor(props) {
    super(props);
    this.state = { matches: window.matchMedia('(max-width:600px)').matches };
  }
  render() {
    const { open, onClose } = this.props;
    return (
      <Grid container>
        <Dialog
          fullWidth={true}
          maxWidth={'xs'}
          onClose={onClose}
          open={open}
          style={this.state.match ? {} : { marginTop: '6%', marginLeft: '2.5%', height: '75vh' }}
        >
          <DialogTitle>
            <Grid container item xs={12}>
              <Grid container item xs={1}></Grid>
              <Grid container item xs={10} alignContent="center" justify="center">
                <b>이용약관</b>
              </Grid>
              <Grid container item xs={1}>
                <IconButton onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <Grid container justify="center" style={{ padding: '2vh 2vw' }}>
              <div dangerouslySetInnerHTML={{ __html: TermsOfUseText }} />
            </Grid>
          </DialogContent>
        </Dialog>
      </Grid>
    );
  }
}

export default withStyles(styles)(TermsOfUse);
